module.exports = __webpack_public_path__ + "img/chargeManagement.e2140823.svg";